import React from "react";
import section_image from "../images/section-image.png";
import "./Section.less";

const Section = () => {
  return (
    <div className="Section">
      <img
        className="section-image"
        src={section_image}
        height="100%"
        alt="scientia"
      />
    </div>
  );
};
export default Section;
